import React, {createContext, FC, PropsWithChildren, useContext} from 'react';

type CheckoutDetails = {
  accessToken: string;
  jwt: string;
  shopId: string | number;
  origin: string;
  authToken: string;
  authProvider: string;
  rawConsentConfig?: string;
};

const CheckoutHashDetailsProviderContext =
  createContext<CheckoutDetails | null>(null);

export type CheckoutHashDetails = CheckoutDetails;

export const CheckoutHashDetailsProvider: FC<
  PropsWithChildren<{
    checkoutHashDetails: CheckoutHashDetails | null;
  }>
> = ({checkoutHashDetails = null, children}) => {
  return (
    <CheckoutHashDetailsProviderContext.Provider value={checkoutHashDetails}>
      {children}
    </CheckoutHashDetailsProviderContext.Provider>
  );
};

export const useCheckoutHashDetails = (): CheckoutDetails | null => {
  return useContext(CheckoutHashDetailsProviderContext);
};
